/* * Version: 1.0.0
 * Letzte Änderung: 16.09.2026, 12:45
 * Änderungshistorie: Erstellung des Auth-Contexts für das globale State-Management der Administrator-Sitzung.
 * Copyright: BAIT-Tech
 */
import React, { createContext, useState } from 'react';
import apiClient from '../api'; // Import unserer konfigurierten Axios-Instanz

// Wir erstellen den Context, den andere Komponenten abonnieren können
export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  // Zustand für den aktuell eingeloggten Benutzer.
  // Initial versuchen wir, den Benutzer aus dem LocalStorage des Browsers zu laden.
  // So bleibt man auch nach einem Page-Reload eingeloggt.
  const [userInfo, setUserInfo] = useState(() => {
    const savedUser = localStorage.getItem('userInfo');
    return savedUser ? JSON.parse(savedUser) : null;
  });

  // Zustand für Lade-Indikatoren (Spinner) während des Login-Vorgangs
  const [loading, setLoading] = useState(false);
  // Zustand für Fehlermeldungen (z.B. falsches Passwort)
  const [error, setError] = useState(null);

  // Login-Funktion: Sendet Credentials an das Backend
  const login = async (email, password) => {
    setLoading(true);
    setError(null);
    
    try {
      // POST-Anfrage an unseren neuen Auth-Endpunkt im Node-Backend
      const { data } = await apiClient.post('/api/auth/login', { email, password });
      
      // Bei Erfolg: Daten (inkl. JWT-Token) im State und im LocalStorage speichern
      setUserInfo(data);
      localStorage.setItem('userInfo', JSON.stringify(data));
      setLoading(false);
      
      return true; // Signalisiert der UI, dass der Login erfolgreich war
    } catch (err) {
      // Fehlerbehandlung: Zeigt die Nachricht vom Backend (401) oder einen Standard-Fehler
      setError(err.response?.data?.message || err.message);
      setLoading(false);
      return false; // Signalisiert der UI, dass der Login fehlgeschlagen ist
    }
  };

  // Logout-Funktion: Löscht die Sitzung und den Token
  const logout = () => {
    setUserInfo(null);
    localStorage.removeItem('userInfo');
  };

  // Wir stellen alle Werte und Funktionen (userInfo, login, logout, etc.) 
  // der gesamten React-Applikation zur Verfügung.
  return (
    <AuthContext.Provider value={{ userInfo, loading, error, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};